import React from "react";
// UI
import { Loader } from "@mantine/core";
// API
import { userInfoQueryOpts } from "@src/services/apiQueries/userQueries";
import { useQuery } from "@tanstack/react-query";

export function OnlyShowForStaff(
  props: React.PropsWithChildren,
): React.ReactNode {
  const { data: userInfo } = useQuery(userInfoQueryOpts());

  if (!userInfo) {
    return <Loader />;
  }

  if (!userInfo.is_staff) {
    return null;
  }

  return props.children;
}
